import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCurateHomePageHome = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("@honeycomb/curate-home")
      .then((lib) => {
        resolve({
          default: () => <lib.HomePage />,
        });
      })
      .catch(reject);
  });
});

export const LazyCurateHomePageHome = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCurateHomePageHome />
    </Suspense>
  );
};
